import { render } from "./TaskPage.vue?vue&type=template&id=1df77410&scoped=true"
import script from "./TaskPage.vue?vue&type=script&lang=js"
export * from "./TaskPage.vue?vue&type=script&lang=js"

import "./TaskPage.vue?vue&type=style&index=0&id=1df77410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df77410"]])

export default __exports__